var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pt-2",style:({
		backgroundImage: `url(${_vm.backgroundImageUrl})`,
	})},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-60 col-lg-40 pt-3 pt-lg-5"},[_c('img',{staticClass:"ms-auto",attrs:{"src":_vm.imgUrl,"alt":"Solutions hero image"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }